up.$compiler('.delivery-address', ($element) => {
  let unbindAutofillAddress = up.on('click', '[autofill-address]', (event, $activeButton, data) => {
    for (let [key, value] of Object.entries(data)) {
      let $input = $element.find(`[id$="${key}"]`)
      // triggering change updates select2 values
      $input.val(value)
      up.emit($input, 'change')
    }
  });

  return function () {
    unbindAutofillAddress()
  }
});
